import { FEATURE_FLAG } from '~/constants';

import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  featureFlag: FEATURE_FLAG.SUPPLIER_OVERVIEW,
};
